// Typed helpers for the unsubscribe ladder (docs/design/unsubscribe.md), under
// /api/senders/:accountId/:address/unsubscribe. `climb` starts one rung the owner chose: the
// server answers with an approval (one-click POST, run by the executor), a compose draft
// (mailto, sent through /api/compose) or a link for the owner's browser. Nothing here fetches
// a sender's page. URL builders are pure so they can be unit-tested.
import type {
  UnsubscribePreview,
  UnsubscribeResult,
  UnsubscribeRung,
  UnsubscribeView,
} from "@shared/api";
import { api } from "./api";
import { senderUrls } from "./sendersApi";

export const unsubscribeUrls = {
  view: (accountId: string, address: string) =>
    `${senderUrls.sender(accountId, address)}/unsubscribe`,
  preview: (accountId: string, address: string) =>
    `${senderUrls.sender(accountId, address)}/unsubscribe/preview`,
};

export const unsubscribeApi = {
  view: (accountId: string, address: string, signal?: AbortSignal) =>
    api<UnsubscribeView>(unsubscribeUrls.view(accountId, address), { signal }),
  /** The exact URL and fingerprint the one-click approval would bind (computed on the server). */
  preview: (accountId: string, address: string, signal?: AbortSignal) =>
    api<UnsubscribePreview>(unsubscribeUrls.preview(accountId, address), { signal }),
  climb: (accountId: string, address: string, rung: UnsubscribeRung, fingerprint?: string) =>
    api<UnsubscribeResult>(unsubscribeUrls.view(accountId, address), {
      method: "POST",
      body: { rung, fingerprint },
    }),
};
